import React, { useState, useEffect } from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import ErrorMessage from '../../../ErrorMessage';
import OfficeService from '../../../../Services/OfficeService';

/**
 * Office group selector of Office Details (CD-5311). Every office is in a shared office group or in a group of its
 * own, which carries the office's name. Offers the edited office's own group, under the office's name, and the shared
 * groups; other offices' own groups are left out. While the office is in a shared group its own group does not exist,
 * so that option's value is empty and saving it creates the group.
 */
const OfficeDetailsGroupSelect = ({
  value = null,
  className = 'w-100 form-control form-control-sm',
  filterCleared = false,
  fieldName = 'defaultFieldname',
  onChange = () => {},
  editedItem = null,
}) => {
  const [officeGroups, setOfficeGroups] = useState([]);
  const [savedOfficeGroupId] = useState(value);

  useEffect(() => {
    OfficeService.GetOfficeGroups()
      .then((result) => {
        setOfficeGroups(Array.isArray(result) ? result : []);
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('OGS33');
      });
  }, []);

  const ownOfficeGroup = officeGroups.find(
    (officeGroup) => officeGroup.isOwnGroup && `${officeGroup.officeGroupId}` === `${savedOfficeGroupId}`
  );
  const selectValues = [
    { label: editedItem?.Name ?? '', value: ownOfficeGroup?.officeGroupId ?? '', disabled: false },
    ...officeGroups
      .filter((officeGroup) => !officeGroup.isOwnGroup)
      .map((officeGroup) => ({ label: officeGroup.name, value: officeGroup.officeGroupId, disabled: false })),
  ];

  return (
    <SelectFieldCheckbox
      value={value}
      className={className}
      fieldName={fieldName}
      onChange={onChange}
      filterCleared={filterCleared}
      selectValues={selectValues}
    />
  );
};

export default OfficeDetailsGroupSelect;
